import { ContentPage } from "./ContentPage";
import { PLATFORM } from "../../config/platform";

// Reusable content body — used both on the public page and the in-app
// (Settings → About Us) screen.
export const AboutBody = () => (
  <>
    <p>
      {PLATFORM.platform_name} helps businesses of every size run their products,
      warehouses, sales and teams from a single, modern platform. We replace
      spreadsheets and disconnected tools with one reliable source of truth for
      your operations.
    </p>

    <h2>Our mission</h2>
    <p>
      To make inventory and operations software that's powerful enough for
      multi-location enterprises yet simple enough for a single shop to start
      using in minutes.
    </p>

    <h2>What we do</h2>
    <ul className="list-disc">
      <li>Real-time inventory across products, warehouses and categories.</li>
      <li>Purchase, sales, invoicing and payments in one place.</li>
      <li>Role-based access for owners, managers and employees.</li>
      <li>A partner program so resellers can grow with us.</li>
    </ul>

    <h2>Get in touch</h2>
    <p>
      Questions about the platform or pricing? Reach us any time at{" "}
      <a href={`mailto:${PLATFORM.support.contactus_email}`}>
        {PLATFORM.support.contactus_email}
      </a>
      .
    </p>
  </>
);

export const About = ({ onBack }: { onBack: () => void }) => (
  <ContentPage title="About Us" onBack={onBack}>
    <AboutBody />
  </ContentPage>
);

export default About;
